export const BANNER_TIMEOUT = 5000;
